import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import BSLAExternalLinkComponent from '../../helpers/BSLAExternalLinkComponent';

const BSLAWoodstorkLayer = async () => {
    type layerModules = [typeof import('esri/layers/FeatureLayer')];

    const [FeatureLayer] = await (loadModules(['esri/layers/FeatureLayer']) as Promise<layerModules>);

    return new FeatureLayer({
        url: 'https://utility.arcgis.com/usrsvcs/servers/8a88d6fce9dd418d8b0c4c201c0a1330/rest/services/WOOD_STORK_V2/FeatureServer/1',
        visible: false,
        title: 'Wood Stork Foraging Area (USFWS)',
        minScale: 10000000,
        popupTemplate: {
            outFields: ['*'],
            title: 'Wood Stork Foraging Area (USFWS)',
            content: (feature: __esri.Feature) => {
                const node = document.createElement('div');

                const content = (
                    <React.Fragment>
                        <p className="mb-1">
                            Issue: In these areas, the developer may be required to calculate that wetland mitigation efforts fully offset the feeding requirements of the
                            woodstork.
                        </p>
                        <p className="mb-1">
                            Cost: In most instances, type-for-type wetland mitigation simultaneously addresses woodstork requirements. However, in certain situations, woodstork
                            habitat compensation may require additional land or wetland credits be purchased. Seek professional guidance from a reputable environmental consultant
                            to determine how Woodstork habitat affects your project.
                        </p>
                        <BSLAExternalLinkComponent href="https://www.fws.gov/northflorida/Species-Accounts/Wood-stork-2005.htm" />
                    </React.Fragment>
                );

                ReactDOM.render(content, node);

                return node;
            }
        }
    });
};

export default BSLAWoodstorkLayer;
